import {
  Button,
  Div,
  ErrorToast,
  H5,
  Img,
  ModalPortal,
  P,
  Radio,
  agentImage,
  lightTheme,
} from '@vgrubs/components';
import {
  LocationAgent,
  LocationAgentServiceKey,
} from 'components/src/types/api/location.types';
import { useEffect, useState } from 'react';
import { isAgentOnService } from './useLocationAgents';

export const AddAgentToServiceModal = ({
  service,
  closeModal,
  agents,
  onConfirm,
  onAddToLocation,
}: {
  service: { key: LocationAgentServiceKey; label: string } | null;
  closeModal: () => void;
  agents: LocationAgent[];
  onConfirm: (
    agentId: number,
    service: LocationAgentServiceKey
  ) => Promise<boolean>;
  onAddToLocation: () => void;
}) => {
  const [selectedAgentId, setSelectedAgentId] = useState<number | null>(null);

  useEffect(() => {
    if (service) setSelectedAgentId(null);
  }, [service]);

  // Location agents not yet on this service.
  const availableAgents = service
    ? agents.filter((agent) => !isAgentOnService(agent, service.key))
    : [];

  const handleConfirm = async () => {
    if (!service) return;
    if (!selectedAgentId) return ErrorToast('Choose an agent');

    const success = await onConfirm(selectedAgentId, service.key);
    if (success) {
      setSelectedAgentId(null);
      closeModal();
    }
  };

  return (
    <ModalPortal
      isOpen={!!service}
      closeModal={closeModal}
      logo={false}
      header={service ? `Add Agent to ${service.label}` : 'Add Agent'}
      zIndex={141}
      footer={
        availableAgents.length > 0 ? (
          <Button $mt="40" $w="100%" $selected onClick={handleConfirm}>
            Add
          </Button>
        ) : undefined
      }
    >
      {availableAgents.map((agent) => (
        <Div
          key={agent.agentId}
          $box
          $p="18px 24px"
          $flex
          $alignCenter
          $between
          onClick={() => setSelectedAgentId(agent.agentId)}
          $gap="16px"
          $pointer
          $m="8px 0"
        >
          <P
            $bold
            $mb="0"
            $color={selectedAgentId === agent.agentId && lightTheme.primary}
          >
            {agent.name}
          </P>
          <Radio checked={selectedAgentId === agent.agentId} />
        </Div>
      ))}

      {availableAgents.length === 0 && (
        <Div $flex $center $column $height="300px">
          <Img src={agentImage} alt="agent" $width="140px" $widthSM="120px" />
          <H5 $mt="16" $center>
            No agents available to add to this service
          </H5>
          <Button $selected $w="250px" $mt="12" onClick={onAddToLocation}>
            Add more agents to location
          </Button>
        </Div>
      )}
    </ModalPortal>
  );
};
